import { defineMessages } from 'react-intl';

export const scope = 'cb.containers.LocationFieldGroup.AdditionalLocationsFieldGroup';
export default defineMessages({
  blockHeading: {
      id: `${scope}.blockHeading`,
      defaultMessage: 'Cities you service',
    },
    blockHeadingInstruction: {
      id: `${scope}.blockHeadingInstruction`,
      defaultMessage: 'Select all cities where customers can access your services.',
    },
  provinceFieldLabel: {
    id: 'couponLocationField.provinceFieldLabel',
    defaultMessage: 'Province',
  },
  provinceFieldPlaceholder: {
    id: 'couponLocationField.provinceFieldPlaceholder',
    defaultMessage: 'Select a province',
  },
  cityBlockHeading: {
    id: 'couponLocationField.cityBlockHeading',
    defaultMessage: 'Cities',
  },
  additionalLocationsInstructions: {
    id: 'couponLocationField.additionalLocationsInstructions',
    defaultMessage: 'Are there additional cities outside of your primary location where customers can access your services?',
  },
  cityInstruction: {
    id: 'couponLocationField.cityInstruction',
    defaultMessage: 'Select one or more cities, or choose Select All.',
  },
  entityProvinces: {
    id: 'couponLocationField.entityProvinces',
    defaultMessage: 'Provinces',
  },
  entityCities: {
    id: 'couponLocationField.entityCities',
    defaultMessage: 'Cities',
  },
});
